import Vue from 'vue'
import Toast from '@/components/Toast/index'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import store from './store/'
import router from './router'
import httpCreater from '@/util/http'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { sentryCSN } from './config/'
import { mapState } from 'vuex'
import 'vtip/lib/index.min.css'
import Vtip from 'vtip'
import { Select, Option, OptionGroup } from 'element-ui'
import hotkeys from 'hotkeys-js'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: sentryCSN,
    beforeSend(event, hint) {
      if (event.exception) {
        event.exception.values[0].stacktrace.frames.forEach((frame) => {
          frame.filename = frame.filename.substring(frame.filename.lastIndexOf('/'))
        })
      }
      return event
    },
    integrations: [new VueIntegration({ Vue, attachProps: true })],
  })
}

Vue.config.productionTip = false
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(VueI18n)
Vue.use(VueVirtualScroller)

const i18n = new VueI18n({
  locale: store.state.lang, // 语言标识
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    zh: require('./lang/zh'), // 中文语言包
    'zh-CN': require('./lang/zh'), // 中文语言包
    en: require('./lang/en'), // 英文语言包
  },
})

Vue.use(Toast, {
  i18n,
  store,
})

Vue.use(Vtip.directive)
Vue.prototype.$tip = Vtip.tip

hotkeys.filter = ({ target }) => {
  return true
}
Vue.prototype.$hotkeys = hotkeys

Vue.mixin({
  computed: {
    ...mapState({
      darkMode: state => state.darkMode,
    }),
  },
  methods: {
    $loading(status) {
      store.commit('toggleLoading', status)
    },
    /**
     * @param {*} msg
     */
    $broadcast(msg) {
      store.commit('setBroadcast', msg)
    },
  },
})

Object.defineProperty(Vue.prototype, '$locale', {
  get: function () {
    return i18n.locale
  },
  set: function (locale) {
    i18n.locale = locale
  },
})

httpCreater(store, router, (message, res) => {
  Vue.prototype.$toast({
    msg: message,
  })
}).then((http) => {
  Vue.prototype.$http = http

  new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}).catch((err) => {
  console.log(err)
})
